import React from 'react'
import { Link } from 'react-router-dom'

export default function CurrentSkin({ currentSkin, handleArchive }) {
  const skinInfo = currentSkin.skinInfo
  return (
    <div className="box_blog">
      <div className="empty_thumb">
        <img src={skinInfo.preview} width="144" height="108" className="thumb_img" alt="" />
      </div>
      <div className="info_skin">
        <strong className="tit_skin">{ skinInfo.title } { currentSkin.isCustomized && " (사용자 수정)" }</strong>
        {currentSkin.isCustomized && <a href="#" className="btn_post" onClick={(e) => handleArchive(e)}>보관</a>}
        <a href={'/manage/design/skin/download.zip?originalname='+skinInfo.name} className="btn_post">다운로드</a>
        <a href="/manage/design/skin/edit" target="_blank" className="btn_post">편집</a>
      </div>

      <div className="skin_set">
        {skinInfo.useBlogmenu && <Link to={"/design/menu"} className="btn_post">메뉴 설정</Link>}
        {skinInfo.useWizard && <a href={'/admin/skin/wizard/?skin='+skinInfo.name} className="btn_post">스킨 위자드</a>}
      </div>

    </div>
  )
}
